import { DbEntry } from "../types"
import { User } from "./userTypes"

export const getUsersGetAllUrl = () => `/.netlify/functions/usersGetAll`

export async function getUser(
    id: string,
    accessToken?: string
): Promise<DbEntry<User>> {
    try {
        const response = await fetch(`/.netlify/functions/userGet?id=${id}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        if (response.ok) return response.json()
        throw new Error("Could not GET user!")
    } catch (err) {
        // @ts-ignore
        throw new Error(err)
    }
}

export const getOwnUserInfoUrl = () => `/.netlify/functions/userGetOwn`

export const getUserUrl = (id: string) => `/.netlify/functions/userGet?id=${id}`
